import { Elm } from "components/Elm";
import App from "./Main.elm";
import getServerRootUrl, { getHaskellBackendUrl, getRustBackendUrl } from "utilities/getServerRootUrl";
import { getJwt } from "utilities/authentication";
import * as React from "react";
import { RouteComponentProps } from "react-router";

export default function GroupDocuments({
  match: {
    params: { groupId },
  },
}: RouteComponentProps<{ groupId: string }>) {
  return (
    <Elm
      src={App.Elm.GroupDocuments.Main}
      flags={{
        serverUrl: getServerRootUrl() + "/graphql",
        haskellBackendBaseUrl: getHaskellBackendUrl(),
        rustBackendBaseUrl: getRustBackendUrl(),
        jwt: getJwt(),
        groupId,
        initialWidth: window.innerWidth,
      }}
    />
  );
}
